module.exports = __webpack_public_path__ + "media/theme/edit-a4b8d351.svg";